<template>
  <v-form class="form-content pl-5 pr-5 altura-componente-container">
    <paciente-ficha-dados-gerais class="mt-5"/>
    <paciente-ficha-medica class="mt-5"/>
  </v-form>
</template>

<script>
import PacienteFichaDadosGerais from '@/views/pages/cadastros/paciente/comum/ficha/PacienteFichaDadosGerais.vue'
import PacienteFichaMedica from '@/views/pages/cadastros/paciente/comum/ficha/PacienteFichaMedica.vue'

export default {
    name: 'PacienteFicha',
    components: {PacienteFichaMedica, PacienteFichaDadosGerais}
}
</script>

<style scoped lang="stylus">

</style>